export default __webpack_public_path__ + "static/media/02_photo.8c5bd21d.jpg";